"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGenericUser = void 0;
const types_1 = require("../../types");
const utils_1 = require("../../utils");
const getGenericData = {
    [types_1.BusinessUnit.BOT]: {
        name: 'REVENDEDOR',
        catalogName: 'Compre com um revendedor',
        addressHomeState: 'PR',
        catalogSlug: 'revendedor',
    },
    [types_1.BusinessUnit.EUD]: {
        name: 'REPRESENTANTE',
        catalogName: 'Compre com um representante',
        addressHomeState: 'MA',
        catalogSlug: 'representante',
    },
    [types_1.BusinessUnit.EAM]: {
        name: 'REVENDEDOR',
        catalogName: 'Compre com um revendedor',
        addressHomeState: 'PR',
        catalogSlug: 'revendedor',
    },
    [types_1.BusinessUnit.OUI]: {
        name: 'REVENDEDOR',
        catalogName: 'Compre com um revendedor',
        addressHomeState: 'PR',
        catalogSlug: 'revendedor',
    },
    [types_1.BusinessUnit.MLT]: {
        name: 'REVENDEDOR',
        catalogName: 'Compre com um revendedor',
        addressHomeState: 'PR',
        catalogSlug: 'revendedor',
    },
};
const getGenericUser = ({ uf, businessUnit }) => {
    const THUMBNAIL_DEFAULT = (0, utils_1.getThumbnailDefault)(businessUnit);
    return Object.assign({ whatsapp: '', catalogCreated: true, createdAt: '', region: uf || localStorage.getItem('state'), photo: {
            thumbnail: THUMBNAIL_DEFAULT,
            fullSize: THUMBNAIL_DEFAULT,
        }, commercialStructureId: '0', superiorId: 0, id: 'generic-user-id' }, getGenericData[businessUnit]);
};
exports.getGenericUser = getGenericUser;
